import React from 'react';
import { Box } from '@mui/material';

interface NumberBadgeProps {
    value: number;
}

// Neutral grey by design — see insightsTheme.ts: colour is reserved for value/score displays.
const NumberBadge: React.FC<NumberBadgeProps> = ({ value }) => (
    <Box
        sx={{
            width: 26,
            height: 26,
            flexShrink: 0,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 600,
            color: 'gray.100',
            bgcolor: 'gray.30',
        }}
    >
        {value}
    </Box>
);

export default NumberBadge;
